// Безпечний парсінг JSON
export function safeJSONParse(str, def = null) {
    try {
        return JSON.parse(str);
    } catch (error) {
        return def;
    }
}   

// Безпечний парсынг флоат
export function safeFloatParse(input, def = null ) {
    try {
        const numberMatch = `${input}`.match(/-?\d+(\.\d+)?/);
        return numberMatch ? parseFloat(numberMatch[0].replaceAll(`,`,`.`)) : def;
    } catch(error) {
        return def
    }
    
}


// Безпечний парсынг флоат
export function safeIntParse(input, def = null ) {
    try {
        const numberMatch = `${input}`.match(/-?\d+(\.\d+)?/);
        return numberMatch ? parseInt(numberMatch[0].replaceAll(`,`,``).replaceAll(`.`,``)) : def;
    } catch(error) {
        return def
    }
    
} 